import React from "react";
import Footer from "../Fotter";

const AboutUs = () => {
  return (
    <div>
      <div className=" mx-auto px-4 py-6">
        <h2 className="text-5xl font-semibold text-center text-gray-800 mb-6">
          About Us
        </h2>

        <p className="text-lg text-gray-700 mb-6">
          We are India’s Shopping portal based in India, Delivering Products
          only in India and this portal has most of the products from Indian
          Manufactures.
        </p>

        <p className="text-lg text-gray-700 mb-6">
          bharatCod stands as a distinguished online shopping portal in India,
          meticulously crafted to revolutionize the shopping experience for
          discerning consumers throughout the nation. Exclusively serving the
          Indian market, bharatCod offers an extensive array of high-quality
          products sourced from reputable local manufacturers, thereby
          celebrating the richness and diversity of Indian craftsmanship and
          innovation.
        </p>

        <p className="text-lg text-gray-700 mb-6">
          This platform is committed to fostering a seamless shopping journey
          that prioritizes customer satisfaction and convenience. With a focus
          on empowering local businesses, bharatCod champions the spirit of
          entrepreneurship while providing consumers with access to exceptional
          products that reflect the best of Indian artistry.
        </p>

        <p className="text-lg text-gray-700 mb-6">
          In a rapidly evolving digital landscape, bharatCod is dedicated to
          maintaining the highest standards of service and quality. The
          commitment to excellence is evident in every aspect of the shopping
          experience, from user-friendly navigation and secure payment processes
          to responsive customer support that operates around the clock.
        </p>

        <p className="text-lg text-gray-700 mb-6">
          Choosing bharatCod means engaging with a platform that values
          integrity, affordability, and the empowerment of the local economy.
          Each purchase contributes not only to personal satisfaction but also
          supports the growth of businesses that are vital to India’s economic
          fabric.
        </p>

        <p className="text-lg text-gray-700 mb-6">
          Thank you for choosing bharatCod, where a steadfast commitment to
          excellence and authenticity defines every aspect of the shopping
          experience.
        </p>

        <h3 className="text-2xl font-medium text-gray-800 mb-4">
          Key Features:
        </h3>
        <ul className="list-inside pl-5 space-y-4 text-lg text-gray-700">
          <li>
            <strong>Cash on Delivery:</strong> A secure payment option that
            enhances customer confidence by allowing purchases to be inspected
            prior to payment.
          </li>
          <li>
            <strong>24/7 Customer Service:</strong> A dedicated support team
            available around the clock to promptly address inquiries and provide
            assistance, ensuring a seamless shopping experience.
          </li>
          <li>
            <strong>Quality Assurance:</strong> Stringent quality control
            measures ensure that customers receive only the finest products that
            meet high standards of excellence.
          </li>
          <li>
            <strong>Easy Refunds and Returns:</strong> A straightforward return
            policy facilitates hassle-free refunds and exchanges, guaranteeing
            complete satisfaction.
          </li>
          <li>
            <strong>Affordability:</strong> Competitive pricing strategies make
            premium products accessible to a broad audience, solidifying
            bharatCod as the preferred destination for value-conscious shoppers.
          </li>
        </ul>

        <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p>
            <strong>Address:</strong> 403, Shagun Tower, Above Apna Sweets,
            Scheme Number 54,P.u.4,AB Rd,vijay Nagar,Indore,Madhy Pradesh 452010
            Pradesh
          </p>
          <p>
            <strong>Phone:</strong> (+91) 9399456176
          </p>
          <p>
            <strong>E-mail:</strong> info@bharatCod.com
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="http://www.bharatCod.com"
              className="text-blue-500 underline"
            >
              www.bharatCod.com
            </a>
          </p>
          <div className="mb-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
